import React, { useEffect, useRef, useState } from 'react';

// How an element arrives when it scrolls into view. `up` is the original (and default) behaviour.
const VARIANTS = {
  up: 'animate-fade-up',
  left: 'animate-fade-left',
  right: 'animate-fade-right',
  zoom: 'animate-zoom-in',
  clip: 'animate-clip-up',
};

const Reveal = ({ children, className = '', delay = 0, as: Tag = 'div', style, variant = 'up' }) => {
  const ref = useRef(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const node = ref.current;
    if (!node) return undefined;

    if (typeof IntersectionObserver === 'undefined') {
      setVisible(true);
      return undefined;
    }

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setVisible(true);
          observer.disconnect();
        }
      },
      { threshold: 0.15, rootMargin: '0px 0px -60px 0px' }
    );

    observer.observe(node);
    return () => observer.disconnect();
  }, []);

  return (
    <Tag
      ref={ref}
      className={`${visible ? VARIANTS[variant] || VARIANTS.up : 'opacity-0'} ${className}`}
      style={{ ...style, ...(visible ? { animationDelay: `${delay}ms` } : {}) }}
    >
      {children}
    </Tag>
  );
};

export default Reveal;
